import Vue from 'vue';
import MiniCartView from './MiniCartView/MiniCartView.vue';
import {INIT_BUYER_DATA, INIT_CART, INIT_IS_GUEST_ORDER, INIT_USER} from '../../store/commits';
import {clickOutside} from '../../Utilities/directives';

export class MiniCart {
  dataObject: any;
  store: any;
  i18n: any;
  application: any;
  elementClassList: string | null = '';

  constructor(appElement: HTMLElement, dataObject: any, store, i18n) {
    this.dataObject = dataObject;
    this.store = store;
    this.i18n = i18n;

    this.mountApplication(appElement);

    window.addEventListener('RerenderTicketshop', (e) => {
      this.resetApplication();
    });
  }

  mountApplication(appElement: HTMLElement) {
    const store = this.store;
    const i18n = this.i18n;
    this.elementClassList = appElement.classList.value;
    this.application = new Vue({
      el: appElement,
      template: `
        <mini-cart-view
          inventory-url="${this.dataObject.inventory}"
          cart-url="${this.dataObject.cartPage}"
          login-url="${this.dataObject.loginPage}"
          shop-url="${this.dataObject.shopPage}"
          login-system-url="${this.dataObject.login}"
          :ticket-nav-item-state="${this.dataObject.ticketNavItemState} === 1"
          :cart-nav-item-state="${this.dataObject.cartNavItemState} === 1"
          :login-nav-item-state="${this.dataObject.loginNavItemState} === 1"
        />`,
      components: {MiniCartView},
      store,
      // @ts-ignore
      i18n,
      beforeCreate() {
        this.$store.commit(INIT_IS_GUEST_ORDER);
        this.$store.commit(INIT_USER);
        this.$store.commit(INIT_BUYER_DATA);
      },
    });
  }

  resetApplication() {
    const currentVueAppElement = this.application.$el;
    let newContainer = document.createElement('div');
    newContainer.classList.value = this.elementClassList!;
    currentVueAppElement.parentNode.append(newContainer);
    this.application.$destroy();
    currentVueAppElement.remove();
    const newAppEl = document.querySelector('.js-mini-cart');
    this.mountApplication(newAppEl as HTMLElement);
  }
}
